import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface BoxProps {
    children?: React.ReactNode;
    as?: keyof JSX.IntrinsicElements;
    textAlign?: 'left' | 'center' | 'right';
    width?: string;
    maxWidth?: string;
    marginTop?: 'small' | 'medium' | 'large';
    marginBottom?: 'small' | 'medium' | 'large';
    padding?: 'small' | 'medium' | 'large';
    background?: string;
    borderRadius?: 'sm' | 'md' | 'lg' | 'xl';
    boxShadow?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
    onSubmit?: (e: React.FormEvent) => void;
}

const StyledBox = styled.div<BoxProps>`
  ${({ textAlign }) => textAlign && `text-align: ${textAlign};`}
  ${({ width }) => width && `width: ${width};`}
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
  
  ${({ marginTop }) => {
        switch (marginTop) {
            case 'small': return `margin-top: ${theme.spacing.sm};`;
            case 'medium': return `margin-top: ${theme.spacing.md};`;
            case 'large': return `margin-top: ${theme.spacing.lg};`;
            default: return '';
        }
    }}
  
  ${({ marginBottom }) => {
        switch (marginBottom) {
            case 'small': return `margin-bottom: ${theme.spacing.sm};`;
            case 'medium': return `margin-bottom: ${theme.spacing.md};`;
            case 'large': return `margin-bottom: ${theme.spacing.lg};`;
            default: return '';
        }
    }}
  
  ${({ padding }) => {
        switch (padding) {
            case 'small': return `padding: ${theme.spacing.sm};`;
            case 'medium': return `padding: ${theme.spacing.md};`;
            case 'large': return `padding: ${theme.spacing.lg};`;
            default: return '';
        }
    }}
  
  ${({ background }) => background && `background-color: ${background};`}
  
  ${({ borderRadius }) => {
        switch (borderRadius) {
            case 'sm': return `border-radius: ${theme.borderRadius.sm};`;
            case 'md': return `border-radius: ${theme.borderRadius.md};`;
            case 'lg': return `border-radius: ${theme.borderRadius.lg};`;
            case 'xl': return `border-radius: ${theme.borderRadius.xl};`;
            default: return '';
        }
    }}
  
  ${({ boxShadow }) => {
        switch (boxShadow) {
            case 'sm': return `box-shadow: ${theme.shadows.sm};`;
            case 'md': return `box-shadow: ${theme.shadows.md};`;
            case 'lg': return `box-shadow: ${theme.shadows.lg};`;
            case 'xl': return `box-shadow: ${theme.shadows.xl};`;
            default: return '';
        }
    }}
`;

export const Box: React.FC<BoxProps> = ({ children, as = 'div', ...props }) => {
    return (
        <StyledBox as={as} {...props}>
            {children}
        </StyledBox>
    );
};